import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetLand } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetLandField } from '../../../../../queries/useBudgetLandField';

interface PavingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Paving: React.FC<PavingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [paving, set_paving] = useBudgetLandField<number>(
        propertyGuid,
        (b) => (b.values?.['Site Work']?.['Paving'] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Paving': v } } })
    );
    const label = 'Paving';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(paving)}
                />
            ) : (
                <MoneyBox
                    id={'paving'}
                    allowNegative={false}
                    value={paving}
                    onChange={(value) => set_paving(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
